import React, {useEffect} from 'react';
import LayoutContentWrapper from "../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import ContentHeader from "../../components/Layout/Content/ContentHeader/ContentHeader";
import {UIText} from "../../enums/UIText/UIText";
import {useAppSelector} from "../../hooks/redux";
import {getLanguage} from "../../store/selectors/appSelector";
import {getTextByLanguage} from "../../enums/utils/getTextByLanguage";
import styles from './Contacts.module.css'
import {EnumLanguage} from "../../enums/EnumLanguage";
import ContactInformation from "./ContactsInformation/ContactInformation";
import ContactsMap from "./ContactsMap/ContactsMap";


const Contacts = () => {

    const language = useAppSelector(getLanguage)


    useEffect(() => {
        document.title = `${UIText.nav.contacts[language]} - ${UIText.mis[EnumLanguage.ru]}`
    }, [language])

    return (
        <div className={styles.contactsPage}>
            <LayoutContentWrapper>
                <ContentHeader title={getTextByLanguage(UIText.nav.contacts, language)}/>
            </LayoutContentWrapper>

            <ContactsMap/>

            <LayoutContentWrapper>
                <ContactInformation/>
            </LayoutContentWrapper>
        </div>
    );
};

export default Contacts;